import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export interface SawReclassifyProduct {
	ProductId: number;
	PartNumber: string | null;
	ExtendedPartNumber: string | null;
	MeasuredLength: number | null;
	MeasuredMin: number | null;
	MeasuredMax: number | null;
	TargetLength: number | null;
	MinLength: number | null;
	MaxLength: number | null;
	IsFit: number;
}

export interface BundleReclassification {
	ReclassificationId: number;
	BundleId: number;
	NewProductId: number | null;
	NewPartNumber: string | null;
	OriginalPartNumber: string | null;
	IsCutback: boolean;
	// Set when a matching-product work order absorbed the bundle
	ConsumedByWorkOrderId: number | null;
	ConsumedByWorkOrderNumber: string | null;
	ConsumedPartNumber: string | null;
}

// Current reclassification of a bundle (null when never reclassified) — drives
// the "Reclassified → X" / "CUTBACK" mark on the outgoing bundle card.
export const getBundleReclassification = async (
	bundleId: number,
): Promise<BundleReclassification | null> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "BundleId", value: bundleId }];
	const resp = await apiService.callV2(
		"[FAB].[GetBundleReclassification]",
		parameters,
	);
	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching bundle reclassification");
	}
	return get(
		resp,
		"data.tables[0].rows[0]",
		null,
	) as BundleReclassification | null;
};

// All active saw products — the valid reclassification targets, with or
// without a work order on the line. When a bundleId is given, IsFit marks the
// ones whose length window + section/grade match the bundle's measurements.
export const getSawReclassifyProducts = async (
	assetId: number,
	bundleId: number | null = null,
): Promise<SawReclassifyProduct[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetId", value: assetId },
		{ name: "BundleId", value: bundleId },
	];
	const resp = await apiService.callV2(
		"[FAB].[GetSawReclassifyProducts]",
		parameters,
	);
	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching reclassify products");
	}
	return get(resp, "data.tables[0].rows", []) as SawReclassifyProduct[];
};
